<template>
  <div :class="'card'">
    <h2 v-if="isLoading">
      {{ `${__('Aktiverar medlemskap')}` }}
    </h2>

    <h1 v-if="!errorMessage && !isLoading">
      {{ __('Tack!') }}
    </h1>
    <p v-if="!errorMessage && !isLoading">
      {{ __(' Din epost är nu veriferad. Du kan nu stänga denna flik.') }}
    </p>
    <el-message danger v-if="errorMessage" class="margin-bottom-x2">
      {{ errorMessage }}
    </el-message>
    <el-loader margin-top class="margin-bottom-x1" v-if="isLoading" />
  </div>
</template>
<script>
import logScope from 'log-scope'
import httpService from '@/services/httpService'
const log = logScope('verifyUser')

export default {
  data () {
    return {
      loadingDots: '.',
      isLoading: false,
      errorMessage: false,
    }
  },
  props: {
    uid: {
      required: true,
      type: String,
    },
  },
  async mounted () {
    this.init()
  },
  methods: {
    async init () {
      try {
        // const verificationLink = this.link + this.uid
        this.isLoading = true
        const interval = setInterval(() => {
          this.loadingDots += '.'
          if (this.loadingDots.length > 3) {
            this.loadingDots = ''
          }
          if (!this.isLoading) clearInterval(interval)
        }, 500)
        setTimeout(() => {
          if (this.isLoading) {
            log.error('timeout while activiting account')
            this.errorMessage =
              'Kunde inte aktivera kontot. Vänligen försök igen, fungerar inte det kontakta support.'
          }
        }, 15000)

        const request = {
          url: `verifyEmail?uid=${this.uid}`,
          retry: false,
        }

        await httpService.get(request)
        this.isLoading = false
      } catch (err) {
        console.log(err)
        this.isLoading = false
        this.errorMessage =
          'Kunde inte aktivera kontot. Vänligen försök igen, fungerar inte det kontakta support.'
        // log.error(err)
      }
    },
    exit () {
      window.close()
    },
  },
}
</script>
